/**
 * Algolia and other payloads sometimes send a scalar (e.g. string) where `string[]` is expected.
 * Normalizes to a string array so `.map` / iteration is always safe.
 */
export function coerceToStringArray(value: unknown): string[] {
  if (value == null) return [];
  if (Array.isArray(value)) {
    return value.map((x) => String(x));
  }
  if (typeof value === 'string') {
    return value.trim() ? [value] : [];
  }
  return [String(value)];
}
